import { render, staticRenderFns } from "./VacancyAddForm.vue?vue&type=template&id=80affe20&scoped=true&"
import script from "./VacancyAddForm.vue?vue&type=script&lang=js&"
export * from "./VacancyAddForm.vue?vue&type=script&lang=js&"
import style0 from "./VacancyAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VacancyAddForm.vue?vue&type=style&index=1&id=80affe20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80affe20",
  null
  
)

export default component.exports